import { d as o, _ as t } from "./_plugin-vue_export-helper-8568c831.mjs";
import { openBlock as s, createElementBlock as n, normalizeClass as r, normalizeStyle as l, createElementVNode as c } from "vue";
const a = o("Check"), i = /* @__PURE__ */ c("path", {
  d: "M998.4 245.029c-219.429 153.6-398.629 332.8-552.229 552.228-40.228 58.514-128 54.857-164.571-3.657-69.486-106.057-149.943-186.514-256-256-51.2-32.914-18.286-113.371 40.229-98.743C182.857 460.8 274.286 508.343 358.4 585.143c157.257-190.172 358.4-340.114 588.8-435.2 62.171-25.6 106.057 58.514 51.2 95.086",
  fill: "currentColor",
  "fill-opacity": "0.9"
}, null, -1), p = [
  i
];
function m(e, _, d, f, h, u) {
  return s(), n("svg", {
    class: r(e.classes),
    style: l(e.style),
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    role: "presentation"
  }, p, 6);
}
const g = /* @__PURE__ */ t(a, [["render", m]]);
export {
  g as default
};
